import React from 'react';
import PropTypes from 'prop-types';

import { formatDates } from 'lib/Formatting';
import { isTruthy } from 'lib/Helpers';

/**
 * Formats Given Date as Formatted Date String with Timestamp
 * @function DateTimeOnHoverCellRenderer
 * @param {Object} props
 * @return {(ReactElement|String)}
 */
const DateTimeOnHoverCellRenderer = ({ cellData }) => isTruthy(cellData)
  ? (
    <div title={formatDates(cellData, 'DATE_AT_TIME')}>
      {formatDates(cellData, 'MM-DD-YYYY')}
    </div>
  )
  : '-';

DateTimeOnHoverCellRenderer.propTypes = {
  cellData: PropTypes.string,
};

export default DateTimeOnHoverCellRenderer;
